import { MdCancel } from 'react-icons/md';
import styles from './index.module.css';

const Icon = ({ icon: Icon, ...props }) => {
  return <Icon {...props} />;
};

export const AccessDenied = () => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Icon icon={MdCancel} className={styles.icon} />
      </div>
      <h1 className={styles.title}>Access Denied</h1>
      <p className={styles.message}>
        You do not have permission to view this page.
      </p>
      <p className={styles.subMessage}>
        Please check your credentials and try again.
      </p>
      <p className={styles.errorCode}>
        Error Code: <span>403</span>
      </p>
    </div>
  );
};
